
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import useSWR from "swr";
import useAuth from "../../../../initialpage/hooks/useAuth";
import NotFoundPage from "../../StoreComponents/NotFoundPage";
import { API } from "../../StoreComponents/conflict";
import useGetData from "../../StoreComponents/hooks/useGetData";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const englishWordCheck = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*|']*$/;
const ViewPendingRequest = () => {
  const { request_id } = useParams();
  const user = JSON.parse(Cookies.get("user") || '{}');
  const logInStatus = parseInt(Cookies.get("Role"));
  const [denyBox, setDenyBox] = useState(false);
  const [deniedRemark, setDeniedRemark] = useState("");
  const [approveBox, setApproveBox] = useState(true);
  const [proId, setProId] = useState(null);
  const navigate = useNavigate();
  const navigate1 = useNavigate();
  // const { data: viewPendingReq } = requisitionApprovedAdmin(requ_id);
  const [productArray, setProductArray] = useState([]);
  const { CountData } = useGetData();
  const { mutate: mutate1 } = CountData();
  const {
    data: viewPendingReq,
    error,
    mutate,
  } = useSWR(
    request_id
      ? `store/requisition/product/request/admin/details/${request_id}`
      : "",
    fetcher
  );

  useEffect(() => {
    if (viewPendingReq) {
      setProductArray(viewPendingReq.info[0]?.ARRAYDATA);
    }
  }, [viewPendingReq]);

  const handleDeniedRequest = () => {
    //console.log("hitting");
    swal({
      title: "Are you sure?",
      text: "Once deny, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.put("store/requisition/product/request/admin/deny", {
          REQUEST_ID: parseInt(request_id),
          DENY_REMARK: deniedRemark,
          status: 3,
        }).then((res) => {
          //console.log(res);

          setDeniedRemark("");
          mutate1();
          navigate("/requisition/requestProduct");
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };
  const handleApprovedRequest = () => {
    console.log("hitting");
    swal({
      title: "Are you sure?",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (productArray.length > 0) {
          const array = productArray.map((product) => {
            const obj = {
              APPROVED_QTY: product.APPROVED_QTY
                ? product.APPROVED_QTY
                : product.REQUEST_QTY,
              APPROVED_REMARKS: product.APPROVED_REMARKS
                ? product.APPROVED_REMARKS
                : "null",
              PRODUCT_CODE: product.PRODUCT_CODE,
              PRODUCT_NAME: product.PRODUCT_NAME,
              REQUEST_QTY: product.REQUEST_QTY,
              REQUEST_REMARKS: product.REQUEST_REMARKS,
            };
            return obj;
          });

          API.put("store/requisition/product/request/admin", {
            status: 1,
            REQUEST_ID: viewPendingReq.info[0].REQUEST_ID,
            products: array,
          }).then((res) => {
            console.log("d", res);
            if (!res.data.error) {
              mutate1();
              swal({
                title: "Thank You !",
                text: "Successfully Approved",
                icon: "success",
                button: "Ok",
              });

              // PostStoreLog(2, "Store requisition Approve by the admin");
              navigate("/requisition/requestProduct");
            }
          });
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  const updateProduct = (id, value, name) => {
    console.log(id, value, name, productArray);
    return productArray.map((item, index) => {
      let myItem = item;
      // setProId(id);

      if (item.PRODUCT_CODE === parseInt(id)) {
        myItem[name] = value;
      }
    });
  };
  console.log(productArray);
  const [imageStore, setImageStore] = useState("");

  return (
    <>
      <Helmet>
        <title>View Pending Request - BBA STORE</title>
        <meta name="description" content="View Pending Request - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate1(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark"> Pending Request </h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div>
              {!viewPendingReq ? (
                <NotFoundPage />
              ) : (
                <div className="row gx-5">
                  <div className="col-12 col-md-12 col-lg-12">
                    <div>
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr
                              style={{
                                backgroundColor: "#3C8DBC",
                                color: "white",
                                textAlign: "center",
                              }}
                              className=" text-white "
                            >
                              <th colSpan="24">Product Request Details</th>
                            </tr>
                          </thead>

                          {viewPendingReq.info && (
                            <tbody>
                              <tr className="lh-lg">
                                <td colSpan="4" className="fw-normal">
                                  {" "}
                                  Date
                                </td>
                                <td colSpan="8">
                                  {moment(
                                    new Date(
                                      viewPendingReq.info[0]?.REQUEST_DATE
                                    )
                                  ).format(" DD-MM-YYYY")}
                                </td>
                                <td colSpan="4" className="fw-normal">
                                  Designation
                                </td>
                                <td colSpan="8">
                                  {viewPendingReq.info[0]?.DESIGNATION}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4" className="fw-normal">
                                  Employee Name
                                </td>
                                <td colSpan="8">
                                  {viewPendingReq.info[0]?.NAME_ENGLISH}
                                </td>
                                <td colSpan="4" className="fw-normal">
                                  Department
                                </td>
                                <td colSpan="8">
                                  {viewPendingReq.info[0]?.DEPARTEMENT}
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>

                  {approveBox && (
                    <div className="col-12 col-md-12 col-lg-12 text-center mt-5">
                      <div className="mt-3">
                        <div className="table-responsive-sm data-table">
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr
                                style={{
                                  backgroundColor: "#3C8DBC",
                                  color: "white",
                                  textAlign: "center",
                                }}
                                className="text-white text-center"
                              >
                                <th colSpan="1">S/N </th>
                                <th colSpan="2">Products</th>
                                <th colSpan="1">Required</th>
                                <th colSpan="1">Unit</th>
                                <th colSpan="2">Approved</th>
                                <th colSpan="2">Comments </th>
                                <th colSpan="2">Remarks</th>
                              </tr>
                            </thead>
                            {/* productArray */}
                            <tbody>
                              {productArray &&
                                productArray?.map((product, index) => (
                                  <tr key={index}>
                                    <td colSpan="1" className="text-center">
                                      {++index}
                                    </td>
                                    <td colSpan="2">{product.PRODUCT_NAME} </td>
                                    <td colSpan="1">{product.REQUEST_QTY}</td>
                                    <td colSpan="1">{product.UNIT}</td>

                                    <td colSpan="2">
                                      {" "}
                                      <input
                                        type="number"
                                        style={{
                                          width: "100%",
                                          paddingLeft: "5px",
                                          height: "40px",
                                        }}
                                        onChange={(e) => {
                                          updateProduct(
                                            product.PRODUCT_CODE,
                                            parseInt(e.target.value),
                                            "APPROVED_QTY"
                                          );
                                        }}
                                        className="input-field-new text-center"
                                        defaultValue={product.REQUEST_QTY}
                                      />
                                    </td>
                                    <td colSpan="2">
                                      <textarea
                                        type="text"
                                        style={{
                                          width: "100%",
                                          height: "70px",
                                          paddingLeft: "5px",
                                        }}
                                        className="input-field-new"
                                        placeholder={product.REQUEST_REMARKS}
                                        disabled
                                      />
                                    </td>
                                    <td colSpan="2">
                                      <textarea
                                        type="text"
                                        style={{
                                          width: "100%",
                                          height: "70px",
                                          paddingLeft: "5px",
                                        }}
                                        className="input-field-new"
                                        onChange={(e) => {
                                          updateProduct(
                                            product.PRODUCT_CODE,
                                            e.target.value,
                                            "APPROVED_REMARKS"
                                          );
                                        }}
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-primary px-3 mt-4"
                          onClick={handleApprovedRequest}
                        >
                          <i className="fa fa-check" />
                          <span> Approve</span>
                        </button>
                        <button
                          className="btn btn-danger px-3 mt-4 ms-3"
                          onClick={() => {
                            setDenyBox(true);
                            setApproveBox(true);
                          }}
                        >
                          <i className="fa fa-xmark" />
                          <span> Deny</span>
                        </button>
                      </div>
                    </div>
                  )}
                  {denyBox && (
                    <div className="col-12 col-md-12 col-lg-12 text-center mt-5">
                      <div className="d-flex justify-content-center align-items-center  flex-column">
                        <div className="mb-3 w-50">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            {" "}
                            Deny Remarks <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control input-field-new"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            onChange={(e) => {
                              setDeniedRemark(e.target.value);
                            }}
                          ></textarea>
                        </div>
                        <div>
                          <button
                            className="btn btn-primary px-3 mt-4"
                            onClick={handleDeniedRequest}
                          >
                            <i className="fa fa-check" />
                            <span> Submit</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPendingRequest;
